module.exports = __webpack_public_path__ + "img/whatsapp.85d245c3.png";